import React, { useEffect ,useState} from 'react';
import { NavLink, useLocation, Link } from 'react-router-dom';
import AuthService from '../services/AuthService';
import logo from '../assets/images/logo.png';

const Sidebar = ({ notifications }) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const selectedUser = queryParams.get('role');
    const authUser = JSON.parse(localStorage.getItem('user'));
    const currentRole = typeof authUser.role === 'object' ? authUser.role?.name : authUser.role;

    const logout = () => {
        if (window.confirm('Are you sure? you want to logout.')) {
            AuthService.logout();
        }
    };
    const [openDropdown, setOpenDropdown] = useState(null);

    const toggleDropdown = (dropdownId) => {
        setOpenDropdown(openDropdown === dropdownId ? null : dropdownId); // Toggle the dropdown
    };

    useEffect(() => {
        initializeSidebar();

        return () => cleanupSidebar();
    });


    const initializeSidebar = () => {

        const button = document.getElementById('kt_app_sidebar_mobile_toggle');
        if (button) {
            button.addEventListener('click', toggleSidebar);
        }

        const menuLinks = document.querySelectorAll('.menu-link');
        menuLinks.forEach(link => {
            link.addEventListener('click', hideSidebar);
        });

    };

    const toggleSidebar = () => {
        const sidebar = document.getElementById('kt_app_sidebar');
        if (sidebar) {
            sidebar.style.display = (sidebar.style.display === 'block') ? 'none' : 'block';
        }
    };

    const hideSidebar = () => {
        const sidebar = document.getElementById('kt_app_sidebar');
        if (sidebar && window.innerWidth <= 990) {
            sidebar.style.display = 'none';
        }
    };

    const cleanupSidebar = () => {
        const button = document.getElementById('kt_app_sidebar_mobile_toggle');
        if (button) {
            button.removeEventListener('click', toggleSidebar);
        }

        const menuLinks = document.querySelectorAll('.menu-link');
        menuLinks.forEach(link => {
            link.removeEventListener('click', hideSidebar);
        });
    };

    return (
        <div id="kt_app_sidebar" className="app-sidebar flex-column" data-kt-drawer="true" data-kt-drawer-name="app-sidebar" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="225px" data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle">
            <div className="app-sidebar-logo px-6 bg-base" id="kt_app_sidebar_logo">
                <NavLink  to="/dashboard">
                    <img alt="Logo" src={logo} className="text-center app-sidebar-logo-default" style={{ maxWidth: '300px', maxHeight: '60px' }} />
                    <img alt="Logo" src={logo} className="app-sidebar-logo-minimize" style={{ maxWidth: '120px', maxHeight: '40px' }} />
                </NavLink >
                {/* <div id="kt_app_sidebar_toggle" className="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate">
                    <span className="svg-icon svg-icon-2 rotate-180">
                        <i className="fas fa-bars"></i>
                    </span>
                </div> */}
            </div>

            <div className="app-sidebar-menu overflow-hidden flex-column-fluid">
                <div id="kt_app_sidebar_menu_wrapper" className="app-sidebar-wrapper hover-scroll-overlay-y my-5" style={{maxHeight: 'calc(100vh - 120px)', overflowY: 'auto'}}>
                    <div className="menu menu-column menu-rounded menu-sub-indention px-3" id="#kt_app_sidebar_menu" data-kt-menu="true" data-kt-menu-expand="false">


                        <div className="menu-item pt-5">
                            <div className="menu-content">
                                <span className="menu-heading fw-bold text-uppercase fs-7">Navigation Links</span>
                            </div>
                        </div>
                        <div className="menu-item">
                            <NavLink  to="/dashboard" className="menu-link">
                                <span className="menu-icon">
                                    <span className="svg-icon svg-icon-2">
                                        <i className="fas fa-home fs-5"></i>
                                    </span>
                                </span>
                                <span className="menu-title fs-6">Dashboard</span>
                            </NavLink >
                        </div>
                        {AuthService.hasPermission('patients') && (
                            <div data-kt-menu-trigger="click" className={`menu-item menu-accordion ${openDropdown === 'patients' ? 'show' : ''}`}>
                                <span className="menu-link" onClick={() => toggleDropdown('patients')}>
                                    <span className="menu-icon">
                                        <span className="svg-icon svg-icon-2">
                                            <i className="fas fa-user-injured fs-5"></i>
                                        </span>
                                    </span>
                                    <span className="menu-title">Patients</span>
                                    <span className="menu-arrow"></span>
                                </span>
                                <div className={`menu-sub menu-sub-accordion ${openDropdown === 'patients' ? 'show' : ''}`}>
                                    <div className="menu-item">
                                        <NavLink className="menu-link" to="/patients">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title">Patient List</span>
                                        </NavLink>
                                    </div>
                                    <div className="menu-item">
                                        <NavLink className="menu-link" to="/patients/create">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title">Register Patient</span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        )}

                        {AuthService.hasPermission('users') && (
                            <div data-kt-menu-trigger="click" className={`menu-item menu-accordion ${openDropdown === 'users' ? 'show' : ''}`}>
                                <span className="menu-link" onClick={() => toggleDropdown('users')}>
                                    <span className="menu-icon">
                                        <span className="svg-icon svg-icon-2">
                                            <i className="fas fa-users fs-5"></i>
                                        </span>
                                    </span>
                                    <span className="menu-title">Users</span>
                                    <span className="menu-arrow"></span>
                                </span>
                                <div className={`menu-sub menu-sub-accordion ${openDropdown === 'users' ? 'show' : ''}`}>
                                    {['admin'].includes(currentRole) && (
                                        <div className="menu-item">
                                            <Link className={`menu-link ${selectedUser === 'admin' ? 'active' : ''}`} to="/users?role=admin">
                                                <span className="menu-bullet">
                                                    <span className="bullet bullet-dot"></span>
                                                </span>
                                                <span className="menu-title">Admins</span>
                                            </Link>
                                        </div>
                                    )}
                                    <div className="menu-item">
                                        <Link className={`menu-link ${selectedUser === 'doctor' ? 'active' : ''}`} to="/users?role=doctor">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title">Doctors</span>
                                        </Link>
                                    </div>
                                    <div className="menu-item">
                                        <Link className={`menu-link ${selectedUser === 'receptionist' ? 'active' : ''}`} to="/users?role=receptionist">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title">Receptionists</span>
                                        </Link>
                                    </div>
                                    <div className="menu-item">
                                        <Link className={`menu-link ${selectedUser === 'specialist' ? 'active' : ''}`} to="/users?role=specialist">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title">Specialists</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}
                        {AuthService.hasPermission('specialist_visits') && (
                            <div className="menu-item">
                                <NavLink  to="/specialist-visits" className="menu-link">
                                    <span className="menu-icon">
                                        <span className="svg-icon svg-icon-2">
                                            <i className="fas fa-user-md fs-5"></i>
                                        </span>
                                    </span>
                                    <span className="menu-title fs-6">Specialist Visits</span>
                                </NavLink >
                            </div>
                        )}

                        <div className="menu-item">
                            <NavLink  to="/appointments" className="menu-link">
                                <span className="menu-icon">
                                    <i className="fas fa-calendar-check fs-5"></i>
                                </span>
                                <span className="menu-title fs-6">Appointments</span>
                            </NavLink >
                        </div>
                        {AuthService.hasPermission('appointment_reminders') && (
                            <div className="menu-item">
                                <NavLink  to="/appointment-reminders" className="menu-link">
                                    <span className="menu-icon">
                                        <i className="fas fa-bell fs-5"></i>
                                    </span>
                                    <span className="menu-title fs-6">Appointment Reminders</span>
                                </NavLink >
                            </div>
                        )}
                        {AuthService.hasPermission('products') && (
                            <div className="menu-item">
                                <NavLink  to="/products" className="menu-link">
                                    <span className="menu-icon">
                                        <i className="fas fa-box fs-5"></i>
                                    </span>
                                    <span className="menu-title fs-6">Products & Inventory</span>
                                </NavLink >
                            </div>
                        )}
                        {AuthService.hasPermission('orders') && (
                            <div className="menu-item">
                                <NavLink  to="/orders" className="menu-link">
                                    <span className="menu-icon">
                                        <i className="fas fa-shopping-cart fs-5"></i>
                                    </span>
                                    <span className="menu-title fs-6">Sales & Orders</span>
                                </NavLink >
                            </div>
                        )}
                        {AuthService.hasPermission('purchases') && (
                            <div className="menu-item">
                                <NavLink  to="/purchases" className="menu-link">
                                    <span className="menu-icon">
                                        <i className="fas fa-file-invoice-dollar fs-5"></i>
                                    </span>
                                    <span className="menu-title fs-6">Purchases</span>
                                </NavLink >
                            </div>
                        )}
                        {AuthService.hasPermission('expenses') && (
                            <div className="menu-item">
                                <NavLink  to="/expenses" className="menu-link">
                                    <span className="menu-icon">
                                        <i className="fas fa-money-bill-wave fs-5"></i>
                                    </span>
                                    <span className="menu-title fs-6">Expenses</span>
                                </NavLink >
                            </div>
                        )}

                        {AuthService.hasPermission('data_management') && (
                            <div  className="menu-item menu-accordion ">
                                <span className="menu-link" id="menuLink" onClick={() => toggleDropdown('dataManagement')}>
                                    <span className="menu-icon">
                                        <span className="svg-icon svg-icon-2">
                                            <i className="fas fa-box fs-5"></i>
                                        </span>
                                    </span>
                                    <span className="menu-title fs-6">Data Management</span>
                                    <span className="menu-arrow"></span>
                                </span>
                                <div  className={`menu-sub menu-sub-accordion ${openDropdown === 'dataManagement' ? 'show' : ''}`}  >
                                    <div className="menu-item">
                                        <NavLink  to="/checkup-types" className="menu-link">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title fs-6">Checkup Types</span>
                                        </NavLink >
                                    </div>
                                    <div className="menu-item">
                                        <NavLink  to="/insurance-types" className="menu-link">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title fs-6">Insurance Types</span>
                                        </NavLink >
                                    </div>
                                    <div className="menu-item">
                                        <NavLink  to="/product-categories" className="menu-link">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title fs-6">Product Categories</span>
                                        </NavLink >
                                    </div>
                                    <div className="menu-item">
                                        <NavLink  to="/expense-categories" className="menu-link">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title fs-6">Expense Categories</span>
                                        </NavLink >
                                    </div>
                                    <div className="menu-item">
                                        <NavLink  to="/suppliers" className="menu-link">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title fs-6">Suppliers</span>
                                        </NavLink >
                                    </div>
                                    <div className="menu-item">
                                        <NavLink  to="/lens-types" className="menu-link">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title fs-6">Lens Types</span>
                                        </NavLink >
                                    </div>

                                </div>
                            </div>
                        )}
                        {AuthService.hasPermission('reports') && (

                            <div  className="menu-item menu-accordion ">
                                <span className="menu-link" id="menuLink" onClick={() => toggleDropdown('reports')}>
                                    <span className="menu-icon">
                                        <span className="svg-icon svg-icon-2">
                                            <i className="fas fa-chart-bar fs-5"></i>
                                        </span>
                                    </span>
                                    <span className="menu-title fs-6">Reports</span>
                                    <span className="menu-arrow"></span>
                                </span>
                                <div  className={`menu-sub menu-sub-accordion ${openDropdown === 'reports' ? 'show' : ''}`}  >
                                    <div className="menu-item">
                                        <NavLink  to="/reports/sales" className="menu-link">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title fs-6">Sales Reports</span>
                                        </NavLink >
                                    </div>
                                    <div className="menu-item">
                                        <NavLink  to="/reports/purchases" className="menu-link">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title fs-6">Purchase Reports</span>
                                        </NavLink >
                                    </div>
                                    <div className="menu-item">
                                        <NavLink  to="/reports/expenses" className="menu-link">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title fs-6">Expense Reports</span>
                                        </NavLink >
                                    </div>
                                    <div className="menu-item">
                                        <NavLink  to="/reports/inventory" className="menu-link">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title fs-6">Inventory Reports</span>
                                        </NavLink >
                                    </div>
                                    <div className="menu-item">
                                        <NavLink  to="/reports/outstanding-balance" className="menu-link">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title fs-6">Outstanding Balance</span>
                                        </NavLink >
                                    </div>
                                    <div className="menu-item">
                                        <NavLink  to="/reports/specialist-clinic" className="menu-link">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title fs-6">Specialist Clinic</span>
                                        </NavLink >
                                    </div>
                                    <div className="menu-item">
                                        <NavLink  to="/reports/patient-visit-history" className="menu-link">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title fs-6">Patient Visit History</span>
                                        </NavLink >
                                    </div>
                                </div>
                            </div>
                        )}

                        {['admin'].includes(currentRole) && (
                            <div className="menu-item">
                                <NavLink  to="/permissions" className="menu-link">
                                    <span className="menu-icon">
                                        <span className="svg-icon svg-icon-2">
                                            <i className="fas fa-shield-alt fs-5"></i>
                                        </span>
                                    </span>
                                    <span className="menu-title fs-6">Permissions</span>
                                </NavLink >
                            </div>
                        )}


                        <div className="menu-item">
                            <NavLink  to="/account" className="menu-link">
                                <span className="menu-icon">
                                    <span className="svg-icon svg-icon-2">
                                        <i className="fas fa-user-circle fs-5"></i>
                                    </span>
                                </span>
                                <span className="menu-title fs-6">Account </span>
                            </NavLink >
                        </div>

                        <div className="menu-item">
                            <span  className="menu-link" onClick={logout}>
                                <span className="menu-icon">
                                    <span className="svg-icon svg-icon-2 rotate-180">
                                        <i className="fas fa-right-from-bracket fs-5"></i>
                                    </span>
                                </span>
                                <span className="menu-title fs-6">Logout</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
